import React, { Component } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  Card,
  CardBody,
  Alert,
} from "reactstrap";

class ConfirmActionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExecuting: false,
      error: null,
    };
  }

  handleConfirm = async () => {
    this.setState({ isExecuting: true, error: null });
    try {
      await this.props.onConfirm();
    } catch (err) {
      this.setState({ error: err.message || "Thực hiện thất bại." });
    } finally {
      this.setState({ isExecuting: false });
    }
  };

  renderOrderPreview() {
    const { data } = this.props;
    if (!data || !data.tables) return null;

    return (
      <div>
        {data.tables.map((table, i) => (
          <Table key={i} size="sm" striped style={{ fontSize: 13 }}>
            <thead>
              <tr>
                {table.headers.map((h, j) => (
                  <th key={j}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {table.rows.map((row, j) => (
                <tr key={j}>
                  {row.map((cell, k) => (
                    <td key={k}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        ))}
        {data.cards && data.cards.length > 0 && (
          <div className="text-right mt-2">
            {data.cards.map((card, i) => (
              <span
                key={i}
                className="font-weight-bold"
                style={{ fontSize: 18 }}
              >
                {card.title}: {card.formatted}
              </span>
            ))}
          </div>
        )}
      </div>
    );
  }

  renderTaskPreview() {
    const { data } = this.props;
    if (!data || !data.task) return null;
    const task = data.task;

    return (
      <Card className="border">
        <CardBody className="p-3">
          <div style={{ fontSize: 13 }}>
            <div className="mb-2">
              <strong>Tiêu đề:</strong> {task.title}
            </div>
            {task.description && (
              <div className="mb-2">
                <strong>Chi tiết:</strong>
                <div
                  className="text-muted mt-1"
                  style={{ whiteSpace: "pre-wrap" }}
                >
                  {task.description}
                </div>
              </div>
            )}
            <div className="mb-2">
              <strong>Ngày:</strong> {task.date}
              {task.time && ` lúc ${task.time}`}
            </div>
          </div>
        </CardBody>
      </Card>
    );
  }

  renderMessagePreview() {
    const { data } = this.props;
    if (!data || !data.generated_message) return null;

    return (
      <div>
        <div className="mb-2" style={{ fontSize: 13 }}>
          <strong>Gửi đến:</strong> {data.customer_name}
        </div>
        <Card className="border bg-light">
          <CardBody className="p-3">
            <div style={{ fontSize: 14, whiteSpace: "pre-wrap" }}>
              {data.generated_message}
            </div>
          </CardBody>
        </Card>
        <div className="mt-2 text-muted" style={{ fontSize: 12 }}>
          Tin nhắn sẽ được sao chép để bạn gửi qua kênh liên lạc.
        </div>
      </div>
    );
  }

  getTitle() {
    const { data } = this.props;
    if (!data) return "Xác nhận hành động";
    switch (data.action_type) {
      case "create_order":
        return "Xác nhận tạo đơn hàng";
      case "create_task":
        return "Xác nhận tạo công việc";
      case "send_message":
        return "Xác nhận tin nhắn";
      default:
        return "Xác nhận hành động";
    }
  }

  render() {
    const { isOpen, onCancel, data } = this.props;
    const { isExecuting, error } = this.state;

    return (
      <Modal isOpen={isOpen} toggle={onCancel} size="md">
        <ModalHeader toggle={onCancel}>
          <i className="simple-icon-check mr-2" />
          {this.getTitle()}
        </ModalHeader>
        <ModalBody>
          {error && <Alert color="danger">{error}</Alert>}

          {data && data.text && (
            <p style={{ fontSize: 14 }}>{data.text}</p>
          )}

          {data?.action_type === "create_order" && this.renderOrderPreview()}
          {data?.action_type === "create_task" && this.renderTaskPreview()}
          {data?.action_type === "send_message" && this.renderMessagePreview()}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={onCancel}
            disabled={isExecuting}
            size="sm"
          >
            Hủy
          </Button>
          <Button
            color="primary"
            onClick={this.handleConfirm}
            disabled={isExecuting}
            size="sm"
          >
            {isExecuting ? (
              <>
                <span className="spinner-border spinner-border-sm mr-1" />
                Đang xử lý...
              </>
            ) : (
              <>
                <i className="simple-icon-check mr-1" />
                Xác nhận
              </>
            )}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ConfirmActionModal;
